<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup manager filter
 * @created at      :   2022/07/25
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapMutations, mapState } from 'vuex';
import repository from '@/utils/repository';
import helpers from '@/utils/helpers';
import messages, { MSG_TYPE } from '@/utils/messages';
import _ from 'lodash';
import uuid from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';

const initFilter = [
    {
        columnno: 0,
        field: 0,
        fields: [],
        condition: 0,
        conditions: [],
        value: '',
        inputformat: 2
    }
];

const initDetail = {
    savecheck: '0',
    filtername: '',
    value: ''
};
/**
 * Define component chat for show page chat
 */
var PopupFilter = {
    template: template,
    props: {
        filterId: String | Number,
        type: String | Number,
        screen: String,
        isUseOriginUser: {
            type: Boolean,
            default: false
        },
        isDisabled: Boolean,
        modelValue: Boolean,
        onSelected: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            filters: [{ ...initFilter }],
            detail: { ...initDetail },
            id: 0,
            uuid: uuid.uuid(),
            canDel: false,
            columns: [],
            fields: [],
            conditions: [],
            optionsOfType3: [
                {
                    code: 1,
                    name: 'する'
                },
                {
                    code: 2,
                    name: 'しない'
                }
            ],
            optionsOfType4: [
                {
                    code: 1,
                    name: '男性'
                },
                {
                    code: 2,
                    name: '女性'
                }
            ],
            optionsOfType5: [
                {
                    code: 1,
                    name: '自動設定'
                },
                {
                    code: 2,
                    name: '個別設定'
                }
            ],
            optionsOfType7: [
                {
                    code: 1,
                    name: '利用者'
                },
                {
                    code: 2,
                    name: '上司'
                },
                {
                    code: 3,
                    name: '管理者'
                }
            ],
            optionsOfType8: [
                {
                    code: 1,
                    name: '可'
                },
                {
                    code: 2,
                    name: '不可'
                }
            ]
        };
    },
    computed: {
        ...mapState('app', ['user']),
        showModal: {
            get() {
                return this.modelValue;
            },
            set() {}
        }
    },
    methods: {
        ...mapMutations('app', ['showModalMessage', 'hideHeaderError']),
        close() {
            this.$emit('update:modelValue', false);
            this.hideHeaderError();
            this.resetData();
        },
        onShow() {
            this.id = helpers.isNullOrEmpty(this.filterId) ? 0 : this.filterId;
            this.getFilters();
            this.hideHeaderError();
        },
        addRow() {
            this.filters.push({ ...initFilter });
        },
        deleteRow(i) {
            this.filters.splice(i, 1);
            if (this.filters.length == 0) {
                this.addRow();
            }
        },
        resetData() {
            // eslint-disable-next-line no-undef
            $(`.item-error`).RemoveError();
            this.id = 0;
            this.canDel = false;
            this.detail = { ...initDetail };
            this.filters = [{ ...initFilter }];
        },
        initScreen() {
            const vm = this;
            vm.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                content: messages.C012,
                callback: (ok) => {
                    if (ok) {
                        this.resetData();
                    }
                }
            });
        },
        setEmployee(i, item, selectItem, input) {
            this.filters[i].value = selectItem ? selectItem.コード : input;
            this.filters[i].value_nm = selectItem ? selectItem.氏名 : '';
        },
        getFilters() {
            repository
                .get(`/common/filters/${this.id ?? 0}`, {
                    params: {
                        isUseOriginUser: this.isUseOriginUser ? 1 : 0,
                        screen: this.screen
                    }
                })
                .then((res) => {
                    const body = res.data;
                    if (body.Code === 200) {
                        const data = body.Data;
                        if (data.detail.filtername) {
                            this.detail = data.detail;
                            this.canDel = true;
                        } else {
                            this.detail = { ...initDetail };
                            this.canDel = false;
                        }
                        if (this.screen != 'gr0590r') {
                            this.columns = _.map(data.columns, (x) => {
                                return {
                                    code: x.columnno,
                                    name: x.columnname
                                };
                            });
                            this.fields = data.fields;
                            this.conditions = data.conditions;
                            this.filters = _.map(data.filters, (item) => {
                                const tmp = { ...item }.valueOf();
                                this.getFields(tmp);
                                tmp.field = item?.field ?? 0;
                                this.getConditions(tmp, true);
                                tmp.condition = item?.condition ?? 0;
                                this.getInputFormat(tmp);
                                tmp.value = item?.value ?? '';
                                tmp.value_nm = item?.value_nm ?? '';
                                this.setOptions(tmp, tmp.options);
                                return tmp;
                            });
                            if (this.filters.length == 0) {
                                this.filters = [{ ...initFilter }];
                            }
                        }
                    } else {
                        this.resetData();
                    }
                });
        },
        setOptions(item, options) {
            if (item.columnno == 2 && item.field == 1) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.事業所コード,
                        name: x.事業所名
                    };
                });
            } else if (item.columnno == 2 && item.field == 2) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: `${x.部署コード};${x.グループコード}`,
                        name: x.部署名
                    };
                });
            } else if (item.columnno == 2 && item.field == 4) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.役職コード,
                        name: x.役職名
                    };
                });
            } else if (item.columnno == 2 && item.field == 5) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.業務種類コード,
                        name: x.業務種類名称
                    };
                });
            } else if (item.columnno == 2 && item.field == 7) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.職種コード,
                        name: x.職種名
                    };
                });
            } else if (item.columnno == 2 && item.field == 8) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.部署コード,
                        name: x.部署名称
                    };
                });
            } else if (item.columnno == 5 && item.field == 3) {
                item.options = _.map(options ?? [], (x) => {
                    return {
                        code: x.年休付与コード,
                        name: x.年休付与名称
                    };
                });
            } else {
                item.options = [];
            }
        },
        getFields(item) {
            item.fields = _.map(
                _.filter(this.fields, (x) => {
                    return x.columnno == item.columnno;
                }),
                (x) => {
                    return {
                        code: x.field,
                        name: x.fieldname
                    };
                }
            ).valueOf();
            item.field = 0;
            item.condition = 0;
            item.conditions = [];
            item.value = '';
            item.value_nm = '';
            item.inputformat = 2;
        },
        getSelectedField(item) {
            return _.find(this.fields, (x) => {
                return x.columnno == item.columnno && x.field == item.field;
            });
        },
        getSelectedCondition(item) {
            return _.find(item.conditions, (x) => {
                return x.code == item.condition;
            });
        },
        getConditions(item, noGetOptions = false) {
            const field = this.getSelectedField(item);
            item.conditions = _.map(
                _.filter(this.conditions, (x) => {
                    return x.condition == field?.condition;
                }),
                (x) => {
                    return {
                        code: x.conditionno,
                        name: x.conditionname
                    };
                }
            ).valueOf();
            item.condition = 0;
            item.value = '';
            item.value_nm = '';
            if (!noGetOptions) {
                item.options = [];
                this.getOptions(item);
            }
        },
        getOptions(item) {
            if (
                !(
                    (item.columnno == 2 &&
                        [1, 2, 4, 5, 7, 8].includes(
                            helpers.getNumber(item.field)
                        )) ||
                    (item.columnno == 5 && item.field == 3)
                )
            ) {
                return;
            }
            repository
                .get(`/common/filters/${this.id ?? 0}/options`, {
                    params: {
                        isUseOriginUser: this.isUseOriginUser ? 1 : 0,
                        column: item.columnno,
                        field: item.field
                    }
                })
                .then((res) => {
                    const body = res.data;
                    if (body.Code === 200) {
                        this.setOptions(item, body.Data);
                    } else {
                        item.options = [];
                    }
                });
        },
        getInputFormat(item) {
            const field = this.getSelectedField(item);
            item.inputformat = field?.inputformat ?? '2';
        },
        deleteFilter() {
            const vm = this;
            if (vm.isDisabled || !vm.canDel) {
                return;
            }
            vm.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                content: messages.C059,
                callback: (ok) => {
                    if (ok) {
                        repository
                            .delete(`/common/filters/${this.id ?? 0}`, {
                                params: {
                                    isUseOriginUser: this.isUseOriginUser
                                        ? 1
                                        : 0,
                                    screen: this.screen
                                }
                            })
                            .then((res) => {
                                const { data } = res;
                                if (data.Code === 200) {
                                    this.doApplyFilter({
                                        forceChange: true
                                    });
                                }
                            });
                    }
                }
            });
        },
        validate() {
            // eslint-disable-next-line no-undef
            $(`.item-error`).RemoveError();
            let isValid = true;
            if (
                this.detail.savecheck == 1 &&
                helpers.isNullOrEmpty(this.detail.filtername)
            ) {
                // eslint-disable-next-line no-undef
                $(`#filtername${this.uuid}`).ItemError(messages.E048);
                isValid = false;
            }
            if (this.screen != 'gr0590r') {
                const length = this.filters.length;
                for (let i = 0; i < length; i++) {
                    const item = this.filters[i];
                    const condition = this.getSelectedCondition(item);
                    if (
                        (!helpers.isNullOrEmpty(item.columnno, true) ||
                            !helpers.isNullOrEmpty(item.field, true) ||
                            !helpers.isNullOrEmpty(item.condition, true) ||
                            !helpers.isNullOrEmpty(item.value)) &&
                        !(
                            !helpers.isNullOrEmpty(item.condition, true) &&
                            (condition?.name ?? '').includes('空白')
                        )
                    ) {
                        if (helpers.isNullOrEmpty(item.columnno, true)) {
                            // eslint-disable-next-line no-undef
                            $(`#columnno${this.uuid}${i}`).ItemError(
                                messages.E049
                            );
                            isValid = false;
                        }
                        if (helpers.isNullOrEmpty(item.field, true)) {
                            // eslint-disable-next-line no-undef
                            $(`#field${this.uuid}${i}`).ItemError(
                                messages.E049
                            );
                            isValid = false;
                        }
                        if (helpers.isNullOrEmpty(item.condition, true)) {
                            // eslint-disable-next-line no-undef
                            $(`#condition${this.uuid}${i}`).ItemError(
                                messages.E049
                            );
                            isValid = false;
                        }
                        if (helpers.isNullOrEmpty(item.value)) {
                            // eslint-disable-next-line no-undef
                            $(`#value${this.uuid}${i}`).ItemError(
                                messages.E049
                            );
                            // eslint-disable-next-line no-undef
                            $(`#value${this.uuid}${i}_0`).ItemError(
                                messages.E049
                            );
                            // eslint-disable-next-line no-undef
                            $(`#value${this.uuid}${i}_1`).ItemError(
                                messages.E049
                            );
                            // eslint-disable-next-line no-undef
                            $(`#value${this.uuid}${i}_2`).ItemError(
                                messages.E049
                            );
                            isValid = false;
                        }
                    }
                }
            } else {
                if (helpers.isNullOrEmpty(this.detail.value)) {
                    // eslint-disable-next-line no-undef
                    $(`#value${this.uuid}`).ItemError(messages.E049);
                    isValid = false;
                }
            }
            if (!isValid) {
                // eslint-disable-next-line no-undef
                $(`.item-error`).first().focus();
            }
            return isValid;
        },
        applyFilter() {
            if (this.isDisabled) {
                return;
            }
            console.log(this.detail);
            if ((this.id ?? 0) != 0 && this.detail.savecheck != 1) {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    content: messages.C081.replace(
                        '{0}',
                        this.detail.filtername
                    ),
                    callback: (ok) => {
                        if (ok) {
                            this.saveFilter();
                        }
                    }
                });
            } else {
                this.saveFilter();
            }
        },
        saveFilter() {
            if (!this.validate()) {
                return;
            }
            repository
                .post(`/common/filters`, {
                    p003: this.id ?? 0,
                    p101: this.detail.savecheck,
                    p102: this.detail.filtername,
                    p201: this.detail.value,
                    isUseOriginUser: this.isUseOriginUser ? 1 : 0,
                    screen: this.screen,
                    filters: _.map(this.filters, (x) => {
                        return {
                            columnno: x.columnno,
                            field: x.field,
                            condition: x.condition,
                            value:
                                x.inputformat == 10
                                    ? x.value.replace(/\D/g, '')
                                    : x.value
                        };
                    })
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.doApplyFilter({
                            ...data.Data,
                            forceChange: true
                        });
                    }
                });
        },
        doApplyFilter(data) {
            if (this.onSelected) {
                this.onSelected(data);
            }
            this.close();
        }
    }
};
export default PopupFilter;
</script>
